const DAY_IN_MS = 1000 * 60 * 60 * 24;

export function getDaysSinceDate(dateUtc: string | null | undefined): string {
  if (!dateUtc) return '';

  const date = new Date(dateUtc);
  const now = new Date();

  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return Math.floor((todayOnly.getTime() - dateOnly.getTime()) / DAY_IN_MS).toString();
}
